import React from "react";
import { cn } from "./cn";

const VARIANT = {
  neutral: "bg-cream-deep text-ink-soft border border-arena/10",
  success: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  warning: "bg-amber-100 text-amber-900 border border-amber-200",
  danger: "bg-red-100 text-red-800 border border-red-200",
  info: "bg-sky-100 text-sky-800 border border-sky-200",
  gold: "bg-gold/20 text-gold-dim border border-gold/35",
};

export default function Badge({ variant = "neutral", className, children, ...rest }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold tracking-wide",
        VARIANT[variant] ?? VARIANT.neutral,
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
